import { render, staticRenderFns } from "./ImportSamplesCSV.vue?vue&type=template&id=053a2051&scoped=true&"
import script from "./ImportSamplesCSV.vue?vue&type=script&lang=ts&"
export * from "./ImportSamplesCSV.vue?vue&type=script&lang=ts&"
import style0 from "./ImportSamplesCSV.vue?vue&type=style&index=0&id=053a2051&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053a2051",
  null
  
)

export default component.exports